// extracted by mini-css-extract-plugin
module.exports = {"modal-root":"Modal_modal-root__2ie6I","modal-root__container":"Modal_modal-root__container__386Kx","modal-root--hidden":"Modal_modal-root--hidden__gnJW-"};